import { SubText, Text } from '@procurify/ui'

import { type ConversationDetailTextBlock } from '../../value-objects/ConversationTurnItem'
import { ConversationRichText } from '../ConversationRichText'
import { CatalogItemDetailsAnalysisTextStyled } from './styles/CatalogItemDetailsAnalysisTextStyled'

export interface ICatalogItemDetailsTextBlockProps {
  block: ConversationDetailTextBlock
  isCallout: boolean
}

export const CatalogItemDetailsTextBlock = ({
  block,
  isCallout,
}: ICatalogItemDetailsTextBlockProps) => {
  if (block.variant === 'caption') {
    return (
      <SubText color='textSecondary' className='fs-mask'>
        <ConversationRichText content={block.content} />
      </SubText>
    )
  }
  if (isCallout) {
    return (
      <CatalogItemDetailsAnalysisTextStyled className='fs-mask'>
        <ConversationRichText content={block.content} />
      </CatalogItemDetailsAnalysisTextStyled>
    )
  }
  return (
    <Text className='fs-mask'>
      <ConversationRichText content={block.content} />
    </Text>
  )
}
